import { useLocation } from 'js/lib/useRouter';

/**
 * There is an edge case where for some lab item launch urls we dont want to redirect
 */
export const useShouldAllowLabPageAccess = () => {
  const location = useLocation();
  return location.pathname.endsWith('/lab') && !!location.query?.programId;
};
